import { render, staticRenderFns } from "./DialogTeacherProfiles.vue?vue&type=template&id=99f658a8&scoped=true"
import script from "./DialogTeacherProfiles.vue?vue&type=script&lang=js"
export * from "./DialogTeacherProfiles.vue?vue&type=script&lang=js"
import style0 from "./DialogTeacherProfiles.vue?vue&type=style&index=0&id=99f658a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f658a8",
  null
  
)

export default component.exports